/* Batch 11 · A8 — "Preparer 46 / 52 · Reviewer 1 40 / 52 …": signed / total per level, for a head folder or the engagement. */
import React from "react";

export default function SignoffRollup({ counts, levels, t, testid }) {
  if (!counts || !levels?.length) return null;
  return (
    <span className="text-[11px] text-muted-foreground" data-testid={testid}>
      {levels.map((lv) => {
        const c = counts[lv] || { signed: 0, total: 0 };
        const full = c.total > 0 && c.signed === c.total;
        return (
          <span key={lv} className={`me-2 ${full ? "text-emerald-700" : ""}`}>
            {t(`itemSignoff.level.${lv}`)} {c.signed} / {c.total}
          </span>
        );
      })}
    </span>
  );
}
